export interface LanguagePair {
  /** Source language code (the text you're reading) */
  source: string;
  /** Target language code (the definitions language) */
  target: string;
  /** Display label */
  label: string;
  /** Path to lemmatization JSON for the source language */
  lemmaFile: string;
  /** Path to dictionary JSON for the pair */
  dictFile: string;
  /** Placeholder text for the input textarea */
  placeholderKey: string;
}

export const languagePairs: LanguagePair[] = [
  {
    source: "es",
    target: "en",
    label: "Spanish → English",
    lemmaFile: "/data/es.json",
    dictFile: "/data/es-en.dict.json",
    placeholderKey: "placeholderEsEn",
  },
  {
    source: "en",
    target: "it",
    label: "English → Italiano",
    lemmaFile: "/data/en.json",
    dictFile: "/data/en-it.dict.json",
    placeholderKey: "placeholderEnIt",
  },
];

const STORAGE_KEY = "llemma_lang_pair";

export function getDefaultPair(): LanguagePair {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    const pair = languagePairs.find(p => `${p.source}-${p.target}` === saved);
    if (pair) return pair;
  }
  return languagePairs[0]!;
}

export function savePairChoice(pair: LanguagePair): void {
  localStorage.setItem(STORAGE_KEY, `${pair.source}-${pair.target}`);
}

export function pairId(pair: LanguagePair): string {
  return `${pair.source}-${pair.target}`;
}
